export const coCreationProjectsSelector = state => state.coCreationProjects.get('coCreationProjects');
export const activeIdSelector = state => state.coCreationProjects.get('activeId');
export const coCreationProjectsIsLoadingSelector = state => state.coCreationProjects.get('isLoading');
